import { RootState } from "../../redux";

export const selectAllICProjects = (state: RootState) => state.icprojects.allICProjects;
export const selectAllAvailableICProjects = (state: RootState) => state.icprojects.allAvailableICProjects;
export const selectCurrentICProject = (state: RootState) => state.icprojects.currentICProject;
